import { render, staticRenderFns } from "./foodDrinkServeForm.vue?vue&type=template&id=2c8aad70&"
import script from "./foodDrinkServeForm.vue?vue&type=script&lang=js&"
export * from "./foodDrinkServeForm.vue?vue&type=script&lang=js&"
import style0 from "./foodDrinkServeForm.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "foodDrinkServeForm.vue"
export default component.exports